/**
 * Route shell only. The screen is @alight/enrolment-ui, shared with apps/site
 * — one implementation, two databases (docs/HTBH-MIGRATION.md §8a).
 */
import { createFileRoute } from "@tanstack/react-router";
import { VerifyPage } from "@alight/enrolment-ui";

export const Route = createFileRoute("/auth/verify")({
  component: VerifyPage,
  validateSearch: (s: Record<string, unknown>) => ({
    token: typeof s.token === "string" ? s.token : "",
    redirect: typeof s.redirect === "string" ? s.redirect : "/",
  }),
});
